import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AddPhoneNumberState, addPhoneNumberFeatureKey } from './add-phone-number.reducer';

const getAddPhoneNumberFeature = createFeatureSelector<AddPhoneNumberState>(addPhoneNumberFeatureKey);

export const getAddPhoneNumberCallState = createSelector(getAddPhoneNumberFeature, (state) => {
   return state.callState;
});

export const getMostRecentAccount = createSelector(getAddPhoneNumberFeature, (state) => ({
   accountId: state.accountId,
   name: state.accountName,
}));
